import React from "react";
import styled from "styled-components";

const QuickStartSection = ({
  subscription,
  usersCount,
  downloadAcknowledged,
  isConfirmingDownload,
  downloadStepComplete,
  downloadAppsCheckboxId,
  isDownloadCheckboxDisabled,
  handleDismissGuide,
  handleDownloadAcknowledgementChange,
  onAddSeats,
}) => (
  <QuickStartContainer>
    <QuickStartHeader>
      <div>
        <QuickStartTitle>How to Use emotii.ai</QuickStartTitle>
        <QuickStartSubtitle>
          You're just a few steps away from enabling real-time emotion-aware AI interpretation.
        </QuickStartSubtitle>
      </div>
      {subscription && usersCount > 0 && (
        <DismissButton onClick={handleDismissGuide} disabled={isConfirmingDownload}>
          <DismissIcon aria-hidden />
          Dismiss
        </DismissButton>
      )}
    </QuickStartHeader>

    <QuickStartGrid>
      <QuickStartCard>
        <CardTop>
          <CardIcon>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="48" rx="10" fill="#9E77ED"/>
              <path d="M13 22H35M15 16H33C34.1046 16 35 16.8954 35 18V30C35 31.1046 34.1046 32 33 32H15C13.8954 32 13 31.1046 13 30V18C13 16.8954 13.8954 16 15 16Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </CardIcon>
          {subscription ? <BadgeComplete>Completed</BadgeComplete> : <BadgePending>Pending</BadgePending>}
        </CardTop>
        <CardTitle>Step 1. Activate Your Subscription</CardTitle>
        <CardBody>Unlock all Pro features and experience Real-time AI interpretation for effortless team communication.</CardBody>
      </QuickStartCard>

      <QuickStartCard>
        <CardTop>
          <CardIcon>
            <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.666748" width="48" height="48" rx="10" fill="#9E77ED"/>
              <g clipPath="url(#clip0_33_18150)">
                <path d="M30.0007 33V31C30.0007 29.9391 29.5793 28.9217 28.8292 28.1716C28.079 27.4214 27.0616 27 26.0007 27H18.0007C16.9399 27 15.9225 27.4214 15.1723 28.1716C14.4222 28.9217 14.0007 29.9391 14.0007 31V33M36.0007 33V31C36.0001 30.1137 35.7051 29.2528 35.1621 28.5523C34.6191 27.8519 33.8589 27.3516 33.0007 27.13M29.0007 15.13C29.8611 15.3503 30.6238 15.8507 31.1684 16.5523C31.713 17.2539 32.0086 18.1168 32.0086 19.005C32.0086 19.8932 31.713 20.7561 31.1684 21.4577C30.6238 22.1593 29.8611 22.6597 29.0007 22.88M26.0007 19C26.0007 21.2091 24.2099 23 22.0007 23C19.7916 23 18.0007 21.2091 18.0007 19C18.0007 16.7909 19.7916 15 22.0007 15C24.2099 15 26.0007 16.7909 26.0007 19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <defs><clipPath id="clip0_33_18150"><rect width="24" height="24" fill="white" transform="translate(13.0007 12)"/></clipPath></defs>
            </svg>
          </CardIcon>
          {subscription && usersCount > 0 ? <BadgeComplete>Completed</BadgeComplete> : <BadgePending>Pending</BadgePending>}
        </CardTop>
        <CardTitle>Step 2. Add Seats for Your Team</CardTitle>
        <CardBody>Invite teammates so everyone can collaborate seamlessly.</CardBody>
        {subscription && subscription.status !== "canceled" && (
          <CardFooter>
            <CardLink onClick={onAddSeats}>Add Seats</CardLink>
          </CardFooter>
        )}
      </QuickStartCard>

      <QuickStartCard>
        <CardTop>
          <CardIcon>
            <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.333496" width="48" height="48" rx="10" fill="#9E77ED"/>
              <g clipPath="url(#clip0_33_18161)">
                <path d="M19.9997 28.9999L23.9997 32.9999M23.9997 32.9999L27.9997 28.9999M23.9997 32.9999V23.9999M32.8797 30.0899C33.7491 29.4786 34.401 28.6061 34.741 27.5991C35.0809 26.5921 35.0911 25.503 34.7701 24.4898C34.4491 23.4766 33.8136 22.592 32.9558 21.9645C32.098 21.337 31.0625 20.9991 29.9997 20.9999H28.7397C28.4389 19.8278 27.8762 18.7392 27.0938 17.816C26.3114 16.8928 25.3298 16.1592 24.2229 15.6703C23.116 15.1814 21.9125 14.95 20.7032 14.9934C19.4939 15.0369 18.3102 15.3542 17.2412 15.9214C16.1723 16.4885 15.2459 17.2908 14.5319 18.2678C13.8178 19.2447 13.3347 20.371 13.1189 21.5617C12.9032 22.7524 12.9603 23.9765 13.2861 25.142C13.6118 26.3074 14.1977 27.3837 14.9997 28.2899" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
              <defs><clipPath id="clip0_33_18161"><rect width="24" height="24" fill="white" transform="translate(11.9995 12)"/></clipPath></defs>
            </svg>
          </CardIcon>
          {downloadStepComplete ? <BadgeComplete>Completed</BadgeComplete> : <BadgePending>Pending</BadgePending>}
        </CardTop>
        <CardTitle>Step 3. Download the Apps</CardTitle>
        <CardBody>Stay connected on mobile, web, and desktop — no matter where your teams are.</CardBody>
        {subscription && (
          <CardFooter>
            <CardAcknowledgement>
              <CardCheckbox
                id={downloadAppsCheckboxId}
                type="checkbox"
                checked={downloadAcknowledged}
                onChange={handleDownloadAcknowledgementChange}
                disabled={isDownloadCheckboxDisabled}
              />
              <CardCheckboxLabel htmlFor={downloadAppsCheckboxId}>
                I have downloaded the apps.
              </CardCheckboxLabel>
            </CardAcknowledgement>
            <CardLink onClick={() => window.open("/user-confirmed", "_blank")}>Download Apps</CardLink>
          </CardFooter>
        )}
      </QuickStartCard>
    </QuickStartGrid>
  </QuickStartContainer>
);

export default QuickStartSection;

const QuickStartContainer = styled.div`
  background: #f9f5ff;
  border: 1px solid #f2ebff;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const QuickStartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const QuickStartTitle = styled.h3`
  color: #1d2939;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  margin: 0;
`;

const QuickStartSubtitle = styled.p`
  margin: 2px 0 0 0;
  color: #667085;
  font-size: 14px;
`;

const DismissButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e9d7fe;
  background: white;
  color: #6941c6;
  border-radius: 10px;
  padding: 8px 12px;
  font-weight: 600;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; color: #a07be4; border-color: #efe2ff; }
`;

const DismissIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 5l10 10M15 5L5 15" stroke="#667085" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const QuickStartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  @media (max-width: 1024px) { grid-template-columns: 1fr; }
`;

const QuickStartCard = styled.div`
  background: #ffffff;
  border: 1px solid #e9eaeb;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: #d6bbfb;
    box-shadow: 0px 2px 4px rgba(127, 86, 217, 0.05);
  }
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CardIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

const CardTitle = styled.h4`
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
`;

const CardBody = styled.p`
  color: #667085;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

const CardLink = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: transparent;
  color: #6941c6;
  font-weight: 600;
  cursor: pointer;
`;

const CardAcknowledgement = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const CardCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #6941c6;
  &:focus-visible { outline: 2px solid #6941c6; outline-offset: 2px; }
  &:disabled { cursor: not-allowed; opacity: 0.7; }
`;

const CardCheckboxLabel = styled.label`
  color: #475467;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  user-select: none;
`;

const BadgeBase = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
`;

const BadgeComplete = styled(BadgeBase)`
  background: #ecfdf3;
  color: #067647;
  border: 1px solid #abefc6;
`;

const BadgePending = styled(BadgeBase)`
  background: #fff1f3;
  color: #b42318;
  border: 1px solid #fecdd3;
`;
